var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_186_7664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#B8BCF9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_7664)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.875 25.625H13.125C12.2966 25.625 11.625 24.9534 11.625 24.125V9.875C11.625 9.04662 12.2966 8.375 13.125 8.375H20.2399C20.2406 8.375 20.2417 8.375 20.2425 8.375H20.25C20.37 8.375 20.4724 8.43537 20.541 8.52312L24.2269 12.209C24.315 12.2776 24.375 12.38 24.375 12.5V12.5079C24.375 12.5086 24.375 12.509 24.375 12.5097V24.125C24.375 24.9534 23.7034 25.625 22.875 25.625ZM20.625 9.64287V12.125H23.1071L20.625 9.64287ZM23.625 12.875H20.25C20.0426 12.875 19.875 12.707 19.875 12.5V9.125H13.125C12.711 9.125 12.375 9.461 12.375 9.875V24.125C12.375 24.539 12.711 24.875 13.125 24.875H22.875C23.289 24.875 23.625 24.539 23.625 24.125V12.875ZM21.375 22.625H14.625C14.4176 22.625 14.25 22.4574 14.25 22.25C14.25 22.043 14.4176 21.875 14.625 21.875H21.375C21.5824 21.875 21.75 22.043 21.75 22.25C21.75 22.4574 21.5824 22.625 21.375 22.625ZM21.375 19.625H14.625C14.4176 19.625 14.25 19.4574 14.25 19.25C14.25 19.043 14.4176 18.875 14.625 18.875H21.375C21.5824 18.875 21.75 19.043 21.75 19.25C21.75 19.4574 21.5824 19.625 21.375 19.625ZM21.375 16.625H14.625C14.4176 16.625 14.25 16.4574 14.25 16.25C14.25 16.043 14.4176 15.875 14.625 15.875H21.375C21.5824 15.875 21.75 16.043 21.75 16.25C21.75 16.4574 21.5824 16.625 21.375 16.625Z",
    fill: "white",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_186_7664",
    x: 0.4,
    y: 0.2,
    width: 35.2,
    height: 35.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_186_7664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_186_7664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_7664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificate-icon.b2538dded3b0f34e0ae1619254931e4e.svg";
export { ForwardRef as ReactComponent };